<template lang="pug">
span.inline-flex.items-center.PTag(:class="cn(LinkTypes({ type }), $attrs.class ?? '')")
  slot
  Icon(name="material-symbols-light:close-small" class="ml-1 clickable" v-if="closable" @click="emit('close')")
</template>

<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'


interface Props {
  type?: 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'default' | 'outline' | 'error'
  icon?: Component
  closable?: boolean
}
const LinkTypes = cva('inline-flex border-transparent items-center rounded-md border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-1', {
  variants: {
    type: {
      default: 'text-primary-foreground bg-primary hover:bg-primary/80',
      primary: 'text-primary-foreground bg-primary hover:bg-primary/80',
      success: 'text-white bg-green-700 hover:bg-green-600',
      warning: 'text-white bg-amber-500 hover:bg-amber-500/90',
      danger: 'text-white bg-destructive hover:bg-destructive/80',
      error: 'text-white bg-destructive hover:bg-destructive/80',
      info: 'text-secondary-foreground bg-secondary hover:bg-secondary/80',
      secondary: 'text-secondary-foreground bg-secondary hover:bg-secondary/80',
      outline: 'text-foreground border border-secondary',
    }
  },
  defaultVariants: {
    type: 'primary',
  },
})
withDefaults(defineProps<Props>(), {
  type: 'primary',
  icon: undefined,
  closable: false,
})

const emit = defineEmits([
  'close'
])
</script>
